import { storageService } from "@twiage/core";

import type { ToggleableGlobalOptions } from "../../types/ToggleableGlobalOptions";
import type { ToggleUseModals } from "../../types/ToggleUseModals";

export const toggleUseModals: ToggleUseModals = ({ state }) => {
  state.toggleableGlobalOptions.useModals =
    !state.toggleableGlobalOptions.useModals;

  const toggleableGlobalOptions =
    storageService.getItemAsObject<ToggleableGlobalOptions>(
      "toggleableGlobalOptions",
    );

  if (toggleableGlobalOptions) {
    toggleableGlobalOptions.useModals = state.toggleableGlobalOptions.useModals;

    storageService.save("toggleableGlobalOptions", toggleableGlobalOptions);
  }
};
